module.exports = __webpack_public_path__ + "static/fonts/GroteskDemiBold.1eca48c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GroteskDemiBold.eot
// module id = e8+N
// module chunks = 0